import { VehicleDashboardState } from '@/store/modules/vehicleDashboard/vehicleDashboardState';

const state: VehicleDashboardState = {
    machine: null,
    vehicleType: null,
    definition: null,
    statusTopic: null,
    status: null,
    vehicleState: null,
    cameraTopic: null,
    camera: null,
    maintenanceMode: false,
    maintenanceModeUser: null,
    paused: false,
    followingFootprint: false,
    realtimeMapLayers: {},
    laserscan: null,
    footprint: null,
    robotPosition: null,
    logScreens: null,
    logs: null,
    lastMessageReceived: null,
};

export default state;
